<template>
  <v-footer
    id="core-footer"
    app
    absolute
    height="46"
  >
    <div class="footer-items">
      <span
        v-for="link in links"
        :key="link.name"
      >
        <a
          :href="link.Link"
          class="tertiary--text footer-links">{{ link.name }}</a>
      </span>
    </div>
    <v-spacer/>
    <span class="font-weight-light copyright">
      &copy;2020
      <a
        href="https://www.ornovaintegrasolusi.com"
        target="_blank">PT. Ornova Integra Solusi</a>. All Rights Reserved.
    </span>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
      { name: 'Home', Link: '/dashboard' },
      { name: 'Website', Link: 'https://www.ornovaintegrasolusi.com' }
    ]
  })
}
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
